import React from "react";
import { getStationMetadata } from "../../utils/rawFunction";
import Link from "@mui/material/Link";
import PublicIcon from "@mui/icons-material/Public";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "../../context/TranslationContext";

export default function ECCCLink({ stationId }) {
  const metadata = getStationMetadata(stationId);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { translate } = useTranslation();

  // Don't render if weather forecast is not available for this station
  if (!metadata?.weather_forecast_available) {
    return null;
  }

  const url = `https://weather.gc.ca/en/location/index.html?coords=${metadata.default_latitude},${metadata.default_longitude}`;

  return (
    <Box
      sx={{
        border: "1px solid #b3c6d4",
        borderRadius: 1.5,
        p: isMobile ? "7px 10px" : "8px 16px",
        mt: 2,
        mb: 1,
        fontSize: isMobile ? "0.89rem" : "0.97rem",
        color: "#234",
        display: "flex",
        alignItems: "center",
        background: "none",
      }}
    >
      <PublicIcon
        sx={{
          fontSize: isMobile ? "1.2rem" : "1.5rem",
          color: "#1976d2",
          mr: 1,
          verticalAlign: "middle",
        }}
      />
      <span style={{ display: "inline", verticalAlign: "middle" }}>
        {translate(
          "See the nearest official Environment Canada weather forecast to this location:"
        )}{" "}
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{
            color: "#1976d2",
            fontWeight: 500,
            fontSize: isMobile ? "0.89rem" : "0.97rem",
            verticalAlign: "middle",
          }}
        >
          {translate("Click here")}
        </Link>
      </span>
    </Box>
  );
}
